import "bootstrap/dist/css/bootstrap.min.css";
import { Col, Container } from "react-bootstrap";
import ContactUs from "../../components/common/ContactUs";
import Breadcrumbs from "../../components/common/Breadcrumbs";

const ContactPage = () => {

    const breadCrumbList = [
        { title: "Home", path: "/", active: false, linkClass: "breadcrumb-text" },
        { title: "Contact Us", path: "/contact-us", active: true, linkClass: "text-primary fw-semibold" }
    ]
    const backgroundImageUrl = `${process.env.REACT_APP_CLOUDFRONT_URL}/public/banner/about_us_banner.jpg`;
    return (
        <>
            <Container fluid className="top-banner-small-fit mt-90" style={{ backgroundImage: `url(${backgroundImageUrl})` }}>
                <Container className="my-auto">
                    <Col md={12} className="text-center my-5 py-4">
                        <h1 className="text-light mb-0">Contact Us</h1>
                    </Col>
                </Container>
            </Container>
            <Breadcrumbs breadcrumbData={breadCrumbList} />

            <ContactUs />
        </>
    );
}

export default ContactPage;
